import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from 'src/app/app.component';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { B2cService } from '../../service/b2c.service';
import { LoginService } from '../../service/login.service';
import { MemberService } from '../../service/member.service';
import { NotificationMessagesService } from '@modules/notification-messages/services/notification-messages.service';

declare function callNativeMethodAndroid(memberId: any): any; // Android native method declaration
declare function callIosMethod(memberId: any): any; // IOS native method declaration
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public token;
  public loggedIn = false;
  public currentDate: Date = new Date();
  cookieValue: string;
  public loader: boolean = false;
  public isMobileDevice: boolean = false;
  constructor(
    private toast: ToastrService,
    private cookieService: CookieService,
    private b2cService: B2cService,
    private loginService: LoginService,
    private memberService: MemberService,
    private _serviceRequestService: ServiceRequestService,
    private readonly notificationMessagesService: NotificationMessagesService,
  ) {}
  ngOnInit() {
    this.isRunOnMobileDevice();
    const accessToken = localStorage.getItem('AccessToken');
    this.loader = true;
    if (this.nullAndUndefinedCheck(accessToken)) {
      window.localStorage.removeItem('AccessToken');
      window.localStorage.removeItem('AccessTokenExpirationTime');
      this.initLoginFlow();
    } else {
      AppComponent.accessToken = accessToken;
      this.getMemberDetails();
    }
  }
  public isRunOnMobileDevice(): void {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }
  nullAndUndefinedCheck(value) {
    return [null, undefined, 'null', 'undefined'].includes(value);
  }

  initLoginFlow() {
    this.loader = true;
    window.localStorage.setItem('loginFirst', 'Yes');
    const stateInCookie = this.cookieService.get('State');
    const errorDescription = this.cookieService.get('errorFromB2C');
    const state = this.cookieService.get('stateFromB2C');
    const code = this.cookieService.get('codeFromB2C');
    //window.location.href = this.b2cService.getUrl("signIn");
    const accessToken = localStorage.getItem('AccessToken');

    // Check if the password reset is requried
    if (errorDescription != null && errorDescription.includes('AADB2C90118')) {
      window.location.href = this.b2cService.getUrl('PasswordReset');
    } else if (errorDescription != null && errorDescription.includes('AADB2C99002')) {
      //window.location.href = this.b2cService.getUrl("signIn");
      // alert(
      //   "User does not exist in TAC system.Please Sign Up to continue."
      // );
      alert('User Authentication Failed. Please Contact to TAC Support Team.');
      window.location.href = this.b2cService.getUrl('SignUp');
    }

    // Check if access token is available and the state is same
    else if (!this.nullAndUndefinedCheck(code) && stateInCookie.includes(state)) {
      this.b2cService.getAccessTokenFromB2C(this.b2cService.getUrl('accessToken'), this.b2cService.getParams()).subscribe((response) => {
        const accessToken = response['access_token'];
        const accessTokenExpiration = response['expires_on'];
        // window.sessionStorage.setItem("AccessToken", accessToken);
        // window.sessionStorage.setItem(
        //   "AccessTokenExpirationTime",
        //   accessTokenExpiration
        // );
        localStorage.setItem('AccessToken', accessToken);
        localStorage.setItem('AccessTokenExpirationTime', accessTokenExpiration);
        AppComponent.accessToken = accessToken;
        if (!this.nullAndUndefinedCheck(accessToken)) {
          this.getMemberDetails();
        } else {
          window.location.href = this.b2cService.getUrl('signIn');
        }
        // const accessTokenExpiration = response["expires_on"];
        const refreshToken = response['refresh_token'];
        const refreshTokenExpiry = new Date().getSeconds() + response['refresh_token_expires_in']; //FIXME

        this.cookieService.set('RefreshToken', refreshToken);
        this.cookieService.set('RefreshTokenExpiry', refreshTokenExpiry);
        this.cookieService.set('State', '');
      });
    }
    // If no access token is available in the url, ask for login again
    else {
      window.location.href = this.b2cService.getUrl('signIn');
    }
  }

  public memberDetail: any;
  getMemberDetails() {
    const currentUser: ILoggedInUserViewModel = JSON.parse(localStorage.getItem('user'));
    // localStorage.removeItem("user");
    this.memberService.getMemberDetails().subscribe(
      (response) => {
        if (response != null) {
          if (currentUser != null && response.memberId === currentUser.memberId) {
            response.role = currentUser.role;
            response.roleId = currentUser.roleId;
            response.claims = currentUser.claims;
          }
          localStorage.setItem('user', JSON.stringify(response));
          this.notificationMessagesService.showNotificationMessage.next(true);
          try {
            callNativeMethodAndroid(response.memberId); //calling android native method
          } catch (error) {
            console.log(error);
          }
          try {
            callIosMethod(response.memberId); //calling IOS native method
          } catch (error) {
            console.log(error);
          }
          this.getMemberPreferenceSettings(response);
        } else {
          alert('User Authentication Failed. Please Contact to TAC Support Team.');
          localStorage.clear();
          this.initLoginFlow();
        }
      },
      (error: HttpErrorResponse) => {
        if (error?.error?.message != undefined && error?.error?.message.includes('issuer')) {
          localStorage.clear();
          sessionStorage.clear();
          this.cookieService.deleteAll();
          location.href = 'https://trinityairmedical.okta.com/';
        } else {
          this.loader = false;
          let data = localStorage.getItem('loginFirst');
          if (data == undefined || data == null)
            this.toast.warning('Something Went Wrong !', 'Warning', {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            });
          else window.localStorage.removeItem('loginFirst');
          this.initLoginFlow();
        }
      },
    );
  }
  private getMemberPreferenceSettings(response) {
    this.memberDetail = response;
    this.loader = false;
    this.memberService.GetMemberPreferenceSettings(this.memberDetail.memberId).subscribe(
      (settings) => {
        localStorage.setItem('MemberPreferenceSettings', JSON.stringify(settings));
        this.loggedIn = true;
        this.loginService.raiseEvent(this.loggedIn);
        if (settings.fromDate != null && settings.fromDate != '') {
          if (settings.selectedTimeZone) {
            this._serviceRequestService.currentTimeZone.next(settings.selectedTimeZone.shortName);
          }
        }
        this.redirectPage(this.memberDetail);
      },
      (error) => {
        this.loginService.raiseEvent(this.loggedIn);
        this.redirectPage(this.memberDetail);
        console.log(error);
      },
    );
  }
  redirectPage(data) {
    if (!this.nullAndUndefinedCheck(localStorage.getItem('AccessToken'))) {
      if (data != null && data != undefined) {
        this.cookieService.set('isLogin', 'true');
        this.loginService.redirectToRespectiveDashboard(data.role);
      } else {
        alert('User Not Found');
      }
    }
  }
  showUserNotAllowedAlertAndRedirectToLogin() {
    window.location.href = this.b2cService.getUrl('signIn');
    alert('User not allowed to login. Please contact to the TAC support team.');
    localStorage.clear();
  }
}
